var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('count-up',{attrs:{"id-name":_vm.idName,"end-val":_vm.endVal,"color":_vm.color,"countSize":_vm.countSize,"countWeight":_vm.countWeight}})}
var staticRenderFns = []

export { render, staticRenderFns }